<template>
  <v-card class="pb-3">
    <v-tabs
      v-model="tab"
      background-color="#346da6"
      dark
      @change="onChange"
    >
      <v-tab
        v-for="(item, index) in items"
        :key="index"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="tab"
    >
      <v-tab-item
        v-for="n in items.length"
        :key="n"
      >
        <v-type-setting-options class="ma-5"/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import VTypeSettingOptions from "@/components/organizms/TypeSettingOptions";

export default {
  components: {
    VTypeSettingOptions,
  },

  data: () => ({
    tab: "One",
  }),

  computed: {
    items() {
      return this.$store.state.top.selectedShakaiOptions;
    },
  },

  methods: {
    onChange(num) {
      const currentOption = this.$store.state.top.selectedShakaiOptions[num]
      if(currentOption) {
        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition:
              this.$store.state.top.allConditions.find(condition => condition.code === currentOption.code)
          })
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.tab-original, .tab
  width 40px
  box-shadow 0px 0px 4px 1px #5b5858
  border-radius 4px 4px 0px 0px

  &__content
    width 100
    font-size 10px

</style>
